<template>

  <div class="wrapper">

    <h1 ref="timetable">
      Workshop timetable
    </h1>

    <div class="loading" v-if="!workshops">
      Loading workshops...
    </div>

    <div class="loading" v-if="workshops && workshops.length <= 0">
      <div class="notification">
        All workshops have been postponed until futher notice
      </div>
    </div>

    <div class="blurred filter-wrapper" :class="{'workshop-filter-active': workshopFilterActive}">

      <div class="filters">
        <div class="filter" v-if="workshops && workshops.length > 0">
          <div class="label">Type:</div>
          <a @click="workshopTypeFilter = ''" :class="{'active': workshopTypeFilter === '' }" :key="'all'">All Workshops</a>
          <a v-for="type in typesOfWorkshops" @click="workshopTypeFilter = type" :class="{'active': workshopTypeFilter === type }" :key="type">
            <!-- {{getFilterTypeName(type)}} -->
            {{type}}
          </a>
        </div>
        <div class="filter" v-if="workshops && workshops.length > 0">
          <div class="label">Dates:</div>
          <a @click="workshopMonthFilter = ''" :class="{'active': workshopMonthFilter === '' }" :key="'all'">All Dates</a>
          <a v-for="month in monthsOfWorkshops" @click="workshopMonthFilter = month" :class="{'active': workshopMonthFilter === month }" :key="month">{{month}}</a>
          <!-- monthsOfWorkshops: {{monthsOfWorkshops}} -->
        </div>
      </div>

      <div class="filter-display" v-if="workshops && workshops.length > 0">
        <div class="" v-if="!workshopTypeFilter && !workshopMonthFilter">
          Showing all up coming workshops
        </div>
        <div class="" v-if="!workshopTypeFilter && workshopMonthFilter">
          Showing all workshops in {{workshopMonthFilter}}
        </div>
        <div class="" v-if="workshopTypeFilter && !workshopMonthFilter">
          Showing all up coming {{getFilterTypeName(workshopTypeFilter)}} workshops
        </div>
        <div class="" v-if="workshopTypeFilter && workshopMonthFilter">
          Showing {{getFilterTypeName(workshopTypeFilter)}} workshops in {{workshopMonthFilter}}
        </div>
        <div class="filter-display-action" @click="workshopFilterActive = !workshopFilterActive">
          <span v-if="workshopFilterActive">Hide Filters</span>
          <span v-if="!workshopFilterActive">Show Filters</span>
        </div>
      </div>

    </div>

    <div class="filter-display" v-if="workshops && workshops.length > 0" :class="{'workshop-filter-active': workshopFilterActive}">
      <div class="" v-if="!workshopTypeFilter && !workshopMonthFilter">
        Showing all up coming workshops
      </div>
      <div class="" v-if="!workshopTypeFilter && workshopMonthFilter">
        Showing all workshops in {{workshopMonthFilter}}
      </div>
      <div class="" v-if="workshopTypeFilter && !workshopMonthFilter">
        Showing all up coming {{getFilterTypeName(workshopTypeFilter)}} workshops
      </div>
      <div class="" v-if="workshopTypeFilter && workshopMonthFilter">
        Showing {{getFilterTypeName(workshopTypeFilter)}} workshops in {{workshopMonthFilter}}
      </div>
      <div class="filter-display-action" @click="workshopFilterActive = !workshopFilterActive">
        <span v-if="workshopFilterActive">Hide Filters</span>
        <span v-if="!workshopFilterActive">Show Filters</span>
      </div>
    </div>

    <transition-group
      name=""
      tag="div"
      class="listings"
      :class="{'workshop-filtering': workshopFilteringInProgress}"
    >

      <div class="filter-empty" v-if="(workshops&&workshops.length>0) && (computedWorkshops&&computedWorkshops.length==0)" :key="'no-results'">
        No matching results
        <br>
        <a @click="workshopTypeFilter = ''">Browse all workshops in {{workshopMonthFilter}}</a> or <a @click="workshopMonthFilter = ''">Browse all {{getFilterTypeName(workshopTypeFilter)}} workshops</a>
      </div>

      <div
        class="listing list-complete-item"
        v-for="(workshop, index) in computedWorkshops"
        v-if="workshops && workshops.length > 0"
        :key="workshop.node.id"
      >
        <div class="listing-content">
          <div class="image"></div>
          <!-- <div class="image" :style="{'backgroundImage': 'url(' + workshop.thumbnail + ')'}"></div> -->
          <div class="info">
            <!--
            productTitle
            productDate
            productTime
            productPrice
            productAvailableForSale
            productUrl
            -->
            <h3 class="" v-html="workshop.productTitle"></h3>
            <div>{{workshop.productDate}}</div>
            <div>{{workshop.productTime}}</div>
            <div>{{workshop.productPrice}}</div>
            <!-- <p class="" v-html="workshop.productTitle"></p> -->
            <!-- <div>{{workshop.productDate}}</div>
            <div>{{workshop.productTime}}</div>
            <div>{{workshop.productPrice}}</div> -->
          </div>
          <div class="action">
            <a :href="workshop.productUrl">Details&nbsp;&rarr;</a>
            <div class="status">
              <span v-if="!(workshop.productAvailableForSale)">Sold Out</span>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

  </div>

</template>

<script>
// import gql from 'graphql-tag'
const shopifyAccessToken = 'cd6c295cb0e4c351d45757ab4f18ec80'
const shopifyGraphQL = 'https://shop.hatopress.net/api/graphql'
const shopifyGraphQLQueryByHandle = function (handle = 'workshops') {
  return `
    {
      shop {
        name
        primaryDomain {
          url
          host
          sslEnabled
        }
      }
      collectionByHandle(handle: "workshops") {
        id
        products(first: 100) {
          edges {
            node {
              id
              title
              handle
              options {
                name
                values
              }
              variants(first: 1) {
                edges {
                  node {
                    title
                    selectedOptions {
                      name
                      value
                    }
                    image {
                      src
                    }
                    price
                    availableForSale
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
const shopifyGraphQLConfig = {
  headers: {
    'X-Shopify-Storefront-Access-Token': shopifyAccessToken,
    'Content-Type': 'application/graphql'
  }
}

import _ from 'lodash'
// import Velocity from 'velocity-animate'

export default {
  data () {
    return {
      workshopTypeFilter: '',
      workshopMonthFilter: '',
      workshops: null,
      months: null,
      shop: '',

      shopify_collection_handle: 'workshops',
      workshopFilteringInProgress: false,
      workshopFilterActive: true
      // shopify_workshops: null,
      // shopify_shop: null
    }
  },
  created () {
    // this.fetchData()
    this.runShopifyGraphQLRequest()
    this.debounceShowFilters = _.debounce(() => { this.showFilters() }, 500)
  },
  watch: {
    workshopTypeFilter (oldVal, newVal) {
      this.hideFilters()
    },
    workshopMonthFilter (oldVal, newVal) {
      this.hideFilters()
    }
  },
  computed: {
    computedWorkshops: function () {
      let self = this
      if (!self.workshops) return null
      // return self.workshops.filter(function (item) {
      //   return self.workshopMonthFilter.length > 0 ? item.date.indexOf(self.workshopMonthFilter) >= 0 : true
      //   // return item.msg.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1
      // })
      return _.filter(self.workshops, (ws) => {
        if (this.workshopMonthFilter && this.workshopTypeFilter) {
          return ws.productMonth === this.workshopMonthFilter && ws.customType === this.workshopTypeFilter
        }
        if (this.workshopMonthFilter) {
          return ws.productMonth === this.workshopMonthFilter
        }
        if (this.workshopTypeFilter) {
          return ws.customType === this.workshopTypeFilter
        }
        return true
      })
    },
    monthsOfWorkshops () {
      let self = this
      if (!self.workshops) return null
      let months = _.uniq(_.map(self.workshops, (ws) => ws.productMonth))
      months = _.sortBy(months, (month) => {
        return _.indexOf(['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'], _.toLower(month))
      })
      return _.filter(months, (m) => {
        if (m) {
          return true
        }
        return false
      })
    },
    typesOfWorkshops () {
      let self = this
      if (!self.workshops) return null
      let types = _.uniq(_.map(self.workshops, (ws) => ws.customType))
      return types
    }
  },
  methods: {
    hideFilters () {
      this.workshopFilteringInProgress = true
      this.debounceShowFilters()
    },
    showFilters () {
      this.workshopFilteringInProgress = false
      let top = this.$refs.timetable.offsetTop - 100
      // console.log(this.$refs.timetable.offsetTop)
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    async runShopifyGraphQLRequest () {
      const res = await this.$http.post(shopifyGraphQL, shopifyGraphQLQueryByHandle(this.shopify_collection_handle), shopifyGraphQLConfig)
      this.workshops = res.body.data.collectionByHandle.products.edges
      this.shop = res.body.data.shop

      //
      this.workshops = _.map(this.workshops, (workshop) => {
        workshop.productTitle = this.getShopifyProductTitle(workshop.node.title)
        workshop.productDate = this.getShopifyProductDate(workshop.node.title)
        workshop.productMonth = this.getShopifyProductMonth(workshop.node.title)
        workshop.productTime = this.getShopifyProductTime(workshop.node.title)
        workshop.productPrice = this.getShopifyProductPrice(workshop.node)
        workshop.productAvailableForSale = this.getShopifyProductAvailableForSale(workshop.node)
        workshop.productUrl = this.getShopifyProductURL(workshop.node.handle)
        workshop.customType = this.getFilterTypeName(workshop.productTitle)

        if (workshop.productTitle.indexOf('Booth') > 0) {
          workshop.productTime = 'Selected dates in June and July'
        }

        if (workshop.productTitle.indexOf('Publishing') > 0) {
          workshop.productDate = this.getShopifyProductDate_Publishing(workshop.node.title)
          workshop.productTime = ''
        }

        return workshop
      })
    },
    getShopifyProductURL (productHandle) {
      return `${this.shop.primaryDomain.url}/collections/${this.shopify_collection_handle}/products/${productHandle}`
    },
    getShopifyProductPrice (product) {
      return `£${product.variants.edges[0].node.price}`
    },
    getShopifyProductTags (product) {
      return `${product}`
    },
    getShopifyProductAvailableForSale (product) {
      return `${product.variants.edges[0].node.availableForSale}`
    },
    getShopifyProductTitle (productFullTitle) {
      return _.split(productFullTitle, /:/)[0]
    },
    getShopifyProductDate_Publishing  (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      // let date = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `${month}---`), '---')[0]
      return dateTime
    },
    getShopifyProductDate (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let date = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `${month}---`), '---')[0]
      return date
    },
    getShopifyProductMonth (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let month = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `---${month}---`), '---')[1]
      // month = [month]
      // console.log(`${month}`)
      if (productFullTitle.indexOf('Booth') > 0) {
        // month = ['June', 'July']
      }
      return month
    },
    getShopifyProductTime (productFullTitle) {
      let dateTime = _.split(productFullTitle, /:/)[1]
      let time = _.split(_.replace(dateTime, /(January|February|March|April|May|June|July|August|September|October|November|December)/, (month) => `${month}---`), '---')[1]
      time = _.trim(time, ',')
      time = _.trim(time, ' ')
      return time
    },
    workshopMonthMatch (workshop) {
      return this.workshopMonthFilter ? workshop.productMonth === this.workshopMonthFilter : true
    },
    workshopTypeMatch (workshop) {
      return this.workshopTypeFilter ? workshop.productTitle === this.workshopTypeFilter : true
    },
    getFilterTypeName (productTitle) {
      if (_.includes(_.toLower(productTitle), 'two-colour')) {
        return 'Two-colour Risograph'
      } else
      if (_.includes(_.toLower(productTitle), 'fanzine')) {
        // return 'Risograph Fanzine'
        return 'Self-Publishing'
      } else
      if (_.includes(_.toLower(productTitle), 'clay')) {
        return 'Clay Club'
        // return 'Ceramics'
      } else
      if (_.includes(_.toLower(productTitle), 'kintsugi')) {
        return 'Kintsugi'
        // return 'Ceramics'
      } else
      if (_.includes(_.toLower(productTitle), 'booth')) {
        // return 'Kintsugi'
        return 'Drawing'
      } else
      if (_.includes(_.toLower(productTitle), 'publishing')) {
        // return 'Kintsugi'
        return 'Self-Publishing'
      } else
      if (_.includes(_.toLower(productTitle), 'dye')) {
        // return 'Kintsugi'
        return 'Dyeing'
      } else
      if (_.includes(_.toLower(productTitle), 'kana')) {
        // return 'Kintsugi'
        return 'Ceramics'
      } else {
        return 'Exclusive'
      }
    }
    // fetchData () {
    //   if (process.env.NODE_ENV === 'production') {
    //     this.error = this.workshops = this.months = null
    //     // this.loading = true
    //     // replace `getPost` with your data fetching util / API wrapper
    //     // this.$http.get('./static/timetable.json', (err, tt) => {
    //     //   this.loading = false
    //     //   if (err) {
    //     //     this.error = err.toString()
    //     //   } else {
    //     //     this.workshops = tt.workshops
    //     //     this.months = tt.months
    //     //   }
    //     // })
    //     this.$http.get('./static/timetable.json').then(response => {
    //     // this.$http.get('http://localhost/workshops/static/timetable.json').then(response => {
    //       // success callback
    //       // this.workshops = response.body.workshops
    //       // this.months = response.body.months
    //       return response.json()
    //     }).then(json => {
    //       // error callback
    //       this.workshops = json.workshops
    //       this.months = json.months
    //     }, response => {
    //       // error callback
    //       console.log('error')
    //     })
    //   } else {
    //     let tt = require('../assets/data/timetable.json')
    //     this.workshops = tt.workshops
    //     this.months = tt.months
    //     // this.$http.get('http://localhost/workshops/static/timetable.json', {
    //     //   jsonp: 'callback'
    //     // }).then(response => {
    //     //   // success callback
    //     //   this.workshops = response.body.workshops
    //     //   this.months = response.body.months
    //     // }, response => {
    //     //   // error callback
    //     //   console.log('error')
    //     // })
    //   }
    // },
    // beforeEnter: function (el) {
    //   el.style.opacity = 0
    //   // el.style.height = 0
    // },
    // enter: function (el, done) {
    //   var delay = el.dataset.index * 0
    //   setTimeout(function () {
    //     Velocity(
    //       el,
    //       {
    //         opacity: 1
    //         // ,
    //         // height: '223px'
    //       },
    //       {
    //         complete: done,
    //         duration: 0
    //       }
    //     )
    //   }, delay)
    // },
    // leave: function (el, done) {
    //   var delay = el.dataset.index * 0
    //   setTimeout(function () {
    //     Velocity(
    //       el,
    //       {
    //         opacity: 0
    //         // ,
    //         // height: 0
    //       },
    //       {
    //         complete: done,
    //         duration: 0
    //       }
    //     )
    //   }, delay)
    // }
    // getQuery: function () {
    //   return ''
    //
    //   // disabled below for Analytics testing -> try disabling custom utm injection
    //   //
    //   // let self = this
    //   // let query = '?'
    //   //
    //   // query += '_=_'
    //   // // query += self.$route.query && self.$route.query.length > 0 ? '?' : ''
    //   // query += self.$route.query.utm_campaign ? '&utm_campaign=' + self.$route.query.utm_campaign : ''
    //   // query += self.$route.query.utm_content ? '&utm_content=' + self.$route.query.utm_content + '-timetableaction' : '&utm_content=timetableaction'
    //   // query += self.$route.query.utm_medium ? '&utm_medium=' + self.$route.query.utm_medium : ''
    //   // query += self.$route.query.utm_source ? '&utm_source=' + self.$route.query.utm_source : ''
    //   // query += self.$route.query.utm_term ? '&utm_term=' + self.$route.query.utm_term : ''
    //   // query += self.$route.query.mc_cid ? '&mc_cid=' + self.$route.query.mc_cid : ''
    //   // query += self.$route.query.mc_eid ? '&mc_eid=' + self.$route.query.mc_eid : ''
    //
    //   // return query
    // }
    // ,
    // formattedTitle: function (oldTitle) {
    //   let newTitle = oldTitle.replace('with', '<br>with')
    //   return newTitle || oldTitle
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notification {
  background: #ff0;
  padding: 2.75rem .75rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  border-radius: .5rem;
  width: 90%;
  max-width: 500px;
}
.notification p {
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  // max-width: 500px;
  text-align: left;
}

.wrapper {
  text-align: center;
  background: #fff;
  margin: 0 0;
  padding: 1rem 0 2rem;
}
h2 {

}
h3 {
  font-size: 1.1rem;
  font-weight: 500;
}
.loading {
  margin-top: 100px;
  margin-bottom: 100px;
}
.listings {
  /* display: flex; */
  /* flex-direction: column; */
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  /* border: 2px solid red; */
}
.listing {
  display: block;
  width: 100%;
  max-width: 1000px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  /* border: 1px solid blue; */
  background: white;
}
.listing-content {
  padding: 2rem 3rem;
  text-align: left;
  display: flex;
  justify-content: space-between;
}

.listings {
  opacity: 1;
  transition: all .3s;
}
.workshop-filtering.listings {
  opacity: 0;
  transition: all .0s;
}

.image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #f3f3f3;
  /*background-size: 400px;*/
  background-size: cover;
  background-position: center;
  display: none;
}

.info {
  /*margin-left: 2rem;*/
  margin-right: auto;
  color: #999;
}
.info h3 {
  /*max-width: 400px;*/
  margin-top: 0;
  color: #000;
  max-width: 28em;
}
.action a {
  display: block;
  font-size: .8rem;
  padding: .3rem 1.5em;
  /*border: 1px solid;*/
  border-radius: 8px;
  border-radius: 2px;
  background: hsl(159, 89%, 93%);
  background: hsl(158, 90%, 66%);
}
.action a:hover {
  background: hsl(158, 90%, 50%);
}
.action .status {
  padding: .5rem;
  text-align: center;
  font-size: 0.7em;
  color: #666;
  max-width: 9em
}

.filter-wrapper {
  position: sticky;
  top: 0;
  z-index: 99999;
  background: white;
  padding: .25rem .25rem 0;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filter {
  width: 100%;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  justify-content: flex-start;
  align-items: center;
  height: 2.5rem;
  margin-bottom: .25rem;
  padding: .25rem;

  height: auto;
  flex-wrap: wrap;
}
.filter .label {
  /* text-transform: uppercase; */
  /* font-weight: 500; */
  min-width: 6em;
  text-align: left;
  /* font-size: 0.7rem; */
  /* letter-spacing: 0.1rem; */
  margin-right: 1rem;
  height: 3rem;
  line-height: 3rem;
}
.filter a {
  display: block;
  /*font-size: .8em;*/
  padding: 0 1.5em;
  height: 2rem;
  line-height: 2rem;
  margin: 0 .2rem;
  border-radius: 2px;
  background: #fafafa;
  color: #333;
  cursor: pointer;
  /* border: 1px solid #fafafa; */
  background: #fff;
  border: 1px solid hsl(158, 90%, 66%);
}
.filter a:hover {
  /* background: #ddd; */
  background: hsl(158, 90%, 80%);
  /* border: 1px solid hsl(158, 90%, 66%); */
}
.filter a.active {
  background: #333;
  background: rgb(221,253,242);
  background: hsl(158, 90%, 66%);
  color: #000;
}

.filter-display {
  max-width: 1000px;
  width: 100%;
  margin: 2rem auto 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #ddd;
  text-align: left;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
}
.filter {
  /* padding-left: 1rem;
  padding-right: 1rem;
  display: flex; */
  /* width: 100%; */
  /* flex-wrap: wrap; */
  /* flex-direction: column; */
  /* height: auto; */
  /* justify-content: flex-start;
  align-items: flex-start; */
}
.filter .label {
  height: 1.75rem;
  min-width: auto;
  line-height: 1.75rem;
  width: 100%;
  font-size: 0.8rem;
}
.filter a {
  font-size: .8rem;
  margin-left: 0;
  margin-right: .5rem;
  margin-bottom: .5rem;
  padding-left: .5rem;
  padding-right: .5rem;
}
.filter-wrapper .filter-display{
  display: none
}

.filter-wrapper.workshop-display-action {

}

.filter-display .filter-display-action {
  cursor: pointer;
  display: none;
}

.filter-empty {
  max-width: 1000px;
  width: 100%;
  margin: 4rem auto 6rem;
  text-align: center;
}

.filter-empty a {
  display: inline-block;
  /*font-size: .8em;*/
  padding: .5rem 1.5em;
  margin: 1rem .5rem;
  border-radius: 2px;
  background: #fafafa;
  color: #333;

  background: #333;
  color: #eee;
  cursor: pointer;
}



.list-complete-item {
  /* transition: top .3s linear, opacity .3s linear, position .3s linear, height .3s linear;
  transition: all .3s linear; */
  display: block;
  /* background: yellow; */
  z-index: 9;
  /* margin-right: 10px; */
}
.list-complete-move {
  transition: all 300ms ease-in-out 50ms;
}
.list-complete-enter,
.list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  z-index: 0;
  /* background: blue; */
  transition: all 500ms ease-in-out 200ms;
  /* position: absolute; */
  /* height: 0; */
  /* top: 0; */
  /* left: 0;
  right: 0; */
  /* transition: all 5s; */
  transform: translateY(-30px);
}
.list-complete-leave-active {
  /* background: red; */
  transform: translateY(30px);
  /* position: absolute; */
  z-index: 0;
  /* top: 0; */
  /* left: 0;
  right: 0; */
}



.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}

@media only screen and (max-width: 1000px) {
  h1 {
    font-size: 1.5rem;
    /* position: sticky;
    top: 0;
    z-index: 9999;
    background: white;
    margin: 0;
    padding: 3rem; */
  }
  .info {
    margin-left: 0;
    font-size: .9rem;
    color: #666;
  }
  .image {
    display: none;
  }
  .filter-wrapper {
    position: static;
    padding: .25rem 0 0;
    display: none;
  }

  .filter-display {
    font-size: 0.8rem;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    position: sticky;
    top: 0;
    z-index: 99999;
    background: white;
  }
  .filter-display div:first-child {
    width: 66%
  }
  .workshop-filter-active.filter-wrapper {
    display: block;
    position: sticky;
    top: 0;
    box-shadow: 0 3px 3px 0 rgba(0,0,0,0.1)
  }
  .filter-wrapper .filter-display {
    display: none;
  }
  .workshop-filter-active.filter-wrapper .filter-display {
    margin-top: 0;
    display: flex
  }

  .workshop-filter-active.filter-display  {
    display: none;
  }

  .filter-display .filter-display-action {
    display: block;
  }

  .filters {
    /* flex-direction: row; */
  }
  .filter {
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    /* flex-direction: column; */
    height: auto;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .filter .label {
    height: 1.75rem;
    min-width: auto;
    line-height: 1.75rem;
    width: 100%;
    font-size: 0.8rem;
  }
  .filter a {
    font-size: .8rem;
    margin-left: 0;
    margin-right: .5rem;
    margin-bottom: .5rem;
    padding-left: .5rem;
    padding-right: .5rem;
  }
  .listing-content {
    padding: 1rem;
    position: relative;
  }
  .filter-empty {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .filter-empty a {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .listing-content .info div {
    max-width: 60vw;
  }
  .action {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0 1rem;
  }
  .action a {
    margin-top: .25rem;
    padding: .5rem 1em;
    font-size: .8rem;
    /* margin-left: .5rem; */
  }
}

@media screen and (max-width: 768px) {
  /* .filter {
    max-width: 100%;
    overflow: auto;
  } */
  /* .filter {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  } */
  .filter a {
    /* display: block;
    font-size: 1rem;
    white-space: nowrap; */
    /* padding: .6em 2em;
    margin: 0 .5rem;
    background: #f3f3f3;
    color: #333;
    cursor: pointer; */
  }
  /* .filter .label {
    position: sticky;
    left: 0;
    background: white
  } */
}

@media screen and (max-width: 640px) {
  /* .listing {
    font-size: 1rem;
    padding: 1.5rem 1rem;
  }
  .filter {
    position: sticky;
    top: 0;
    z-index: 9999;
    background: white;
    padding: .75rem;
    margin: 0;
  }
  .filter a {
    display: block;
    font-size: .7em;
    padding: .6em 2em;
    margin: 0 .5rem;
    background: #f3f3f3;
    color: #333;
    cursor: pointer;
  }
  .action {
    padding-left: 1rem;
  }
  .action a {
    text-align: center;
  } */
}
</style>



// WEBPACK FOOTER //
// Timetable.vue?fe3c5734